var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiDialog from '@mui/material/Dialog';
import DialogTitle from './DialogTitle';
/**
 * Pigment [Dialog](https://pigment.customink.com/?path=/docs/components-dialog)
 */
var Dialog = function (_a) {
    var onClose = _a.onClose, title = _a.title, children = _a.children, props = __rest(_a, ["onClose", "title", "children"]);
    return (React.createElement(MuiDialog, __assign({ onClose: onClose }, props),
        React.createElement(DialogTitle, { onClose: onClose }, title),
        children));
};
export default Dialog;
//# sourceMappingURL=Dialog.js.map